module.exports = __webpack_public_path__ + "img/1474176242.13f2b59c.jpg";